export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-up-white.8d4709aa.svg";